import { Pool } from '../../../../../../apis/pool.api';
import {
  CPSConfigAlarm,
  CPSConfigAlarmElement,
  CPSConfigCard,
  IProduct,
  IProductFunctionnality,
} from '../../../IProduct';
import { IMaster } from '../../../IMaster';
import { P00039DataRxTxIndex } from '../../P00039Sync';

export function P0003601Alarm(
  pool: Pool,
  productClass: IProduct,
  masterClass: IMaster,
  getValue: any,
): CPSConfigAlarmElement[] {
  let res: CPSConfigAlarmElement[] = [];

  if (getValue('fvsSAlarme') === 1) {
    if (masterClass.hasProduct(pool, productClass) === 2) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.FILTRATION_VS,
        functionalityTitle: 'dashboard.filtrationvs',
        title: 'P0003601.parameters.status.statut.presenceDuProduit',
      });
    }
  }

  return res;
}
